export const LOGIN_FAIL = 'LOGIN_FAIL';
